<template>
    <vue-draggable-resizable
        v-if="shows"
        v-bind="props_node"
        v-on="{
            activated,
            deactivated,
            dragging,
            resizing,
        }"
        @dragstop="emit"
        @resizestop="emit"
        ref="node-area"
        :key="key"
    >
        <div class="fill-height" style="position: relative" @click.stop>
            <node-area-wrap>
                <node-area-back v-bind="{ value, mode }" />
                <node-area-icon v-bind="{ value, mode }" />
                <slot />
                <node-area-edit v-bind="{ mode, active }" />
            </node-area-wrap>
        </div>
    </vue-draggable-resizable>
</template>

<script>
import { mapState } from "vuex";
import { initEmploymentField } from "@/assets/variables";

import VueDraggableResizable from "vue-draggable-resizable";
import "vue-draggable-resizable/dist/VueDraggableResizable.css";

import NodeAreaBack from "./node-area-back.vue";
import NodeAreaEdit from "./node-area-edit.vue";
import NodeAreaIcon from "./node-area-icon.vue";
import NodeAreaWrap from "./node-area-wrap.vue";

export default {
    components: {
        VueDraggableResizable,

        NodeAreaBack,
        NodeAreaEdit,
        NodeAreaIcon,
        NodeAreaWrap,
    },
    props: {
        value: { type: Object, default: initEmploymentField },

        /** @type {import('vue').PropType<'form'|'sign'|'view'|'done''>} */
        mode: { type: String, default: "form" },
        size: { type: Object, default: () => ({ width: null, height: null }) },
    },
    data: () => ({
        form: null,
        key: 0,
    }),
    computed: {
        props_node() {
            let { active } = this;
            let { width, height } = this.size;

            let classItems = ["node-area"];
            classItems.push(`${classItems.at(-1)}--${this.mode}`);
            classItems.push(`${classItems.at(-1)}--${this.form?.side?.toLowerCase?.()}`);
            if (active) classItems.push(`${classItems.at(0)}--active`);

            let props = {
                active,
                x: width * this.value.axis.x,
                y: height * this.value.axis.y,
                w: width * this.value.size.w,
                h: height * this.value.size.h,
                zIndex: 9,
                draggable: this.mode == "form",
                resizable: this.mode == "form",
                class: classItems.join(" "),
            };
            if (!props.active) delete props.active;
            if (this.mode !== "form") delete props.active;
            return props;
        },
        shows() {
            let { width, height } = this.size;
            let { w, h } = this.props_node;
            return !!width && !!height && !!w && !!h;
        },
        ...mapState("employment/form/node", {
            active(state) {
                return state.active?.tempId == this.form?.tempId;
            },
        }),
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
        size() {
            this.sync();
        },
        active(active) {
            if (this.mode == "form") this.key += 1;
            if (!active) return;

            let intervalId = setInterval(() => {
                let el = this.$refs["node-area"]?.$el;
                if (!el) return;

                clearInterval(intervalId);

                let rect = el.getBoundingClientRect();

                const isVisible = rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
                if (isVisible) return;

                el.scrollIntoView({ behavior: "smooth", block: "center" });
            }, 10);
        },
    },
    methods: {
        sync() {
            this.form = initEmploymentField(this.value);
        },
        emit() {
            this.$emit("input", this.form);
            this.$store.commit("employment/form/node/setActive", this.form);
        },
        activated() {
            this.$store.commit("employment/form/node/setIsEdit", false);
            this.$store.commit("employment/form/node/setActive", this.value);
        },
        deactivated() {
            if (this.mode == "sign") return;
            this.emit();
        },
        dragging(x, y) {
            let { width, height } = this.size;

            this.form.axis.x = x / width;
            this.form.axis.y = y / height;

            this.emit();
        },
        resizing(x, y, w, h) {
            let { width, height } = this.size;

            this.form.axis.x = x / width;
            this.form.axis.y = y / height;
            this.form.size.w = w / width;
            this.form.size.h = h / height;

            this.emit();
        },
    },
};
</script>

<style lang="scss" scoped>
.node-area {
    &--done {
        pointer-events: none;
        border: none !important;
    }

    &--view {
        pointer-events: none;

        &--document {
            border: none !important;
        }
    }
    &--sign {
        &--document {
            pointer-events: none;
            border: none !important;
        }
    }

    &--active {
        &::before {
            content: " ";

            position: absolute;
            right: 50%;
            bottom: 50%;
            transform: translate(50%, 50%);

            width: 100%;
            height: 100%;
            box-sizing: content-box;
            border: 4px solid var(--v-primary-base);
        }
    }
}
</style>
